module.exports = __webpack_public_path__ + "img/bluelogo.bcdd5127.png";